
class ContactRole {

    static EFB_CONTACT = 'EFBContact'
    static PROJECT_LEAD = 'ProjectLead'

}

export default ContactRole